export const DEBOUNCE_WAIT_FOR_SEARCH_TYPING = 350
export const DEBOUNCE_WAIT_FOR_MOUSE_EVENTS = 150
export const DEBOUNCE_WAIT_FOR_SORT = 500
export const DEBOUNCE_WAIT_FOR_SCROLL = 250
export const STATUS_CODE_UNKNOWN = 520
export const DEFAULT_PRIMARY_BATCH_SIZE = 100
export const DEFAULT_SECONDARY_BATCH_SIZE = 400

/**
 * These settings control the thresholds we use for downloading data.
 *
 * NOTE: Increasing the batch size here increases the time spent processing the request. Since these requests are
 * intended to be long-lived, unless you confirm the provider function increases the default request timeout in
 * core-utils/fetch, stick to this smaller batch size.
 */
export const DEFAULT_BATCH_SIZE = 500
export const MAX_DOWNLOAD_COUNT = 50000
